export const tabs = (t) => [
  {
    route: 'cover',
    label: t('case_progress.tabs.cover'),
  },
  {
    route: 'progress',
    label: t('case_progress.tabs.progress'),
  },
];
